"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.taxonomyRanks = void 0;
exports.taxonomyRanks = [
    'superkingdom',
    'kingdom',
    'phylum',
    'class',
    'order',
    'family',
    'genus',
    'species',
];
//# sourceMappingURL=taxonomyRanks.js.map